import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChainCuffLeatherJacket = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.jackets.ChainCuffLeatherJacket.itemName}
      name={SS23.jackets.ChainCuffLeatherJacket.itemName}
      price={SS23.jackets.ChainCuffLeatherJacket.itemPrice}
      fabric={SS23.jackets.ChainCuffLeatherJacket.itemFabric}
      src={SS23.jackets.ChainCuffLeatherJacket.sizeChart}
      divId={SS23.jackets.ChainCuffLeatherJacket.shopifyDivId}
      mainId={SS23.jackets.ChainCuffLeatherJacket.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.jackets.ChainCuffLeatherJacket.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.jackets.ChainCuffLeatherJacket.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChainCuffLeatherJacket;
